import { HeaderLink, TokenData } from "p6m-p6u";
import { cp } from "../config";

export const hasAllowedRole = (roles: TokenData["roles"], allowedRoles: TokenData["roles"]) => {
    return roles.some((role) => allowedRoles.includes(role));
};

interface AccountLinksTranslations {
    myAccount: string;
    myParentAccount: string;
    myLearningAccount: string;
}

interface BuildAccountLinksParams {
    translations: AccountLinksTranslations;
    userRole?: string | null;
}

export const buildAccountLinks = (params: BuildAccountLinksParams): HeaderLink[] => {
    const isTeacherOrParent = hasAllowedRole([params.userRole ?? ""], ["teacher", "parent"]);

    return [
        {
            text: params.translations.myAccount,
            link: `${cp.cfg.REACT_APP_P6_BASE_WEBSITE}schule/account`,
        },
        {
            text: isTeacherOrParent ? params.translations.myParentAccount : params.translations.myLearningAccount,
            link: `${cp.cfg.REACT_APP_P6_BASE_WEBSITE}classic/service/user/parent/`,
        },
    ];
};
